export default function IconMeasure({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={className}
    >
      <path
        d="M10.0843 14.2507L8.5498 12.7162L7.8926 13.3734L9.4271 14.9079L10.0843 14.2507ZM19.7284 4.6066L18.1939 3.0721L17.5367 3.7293L19.0712 5.2638L19.7284 4.6066ZM14.9079 9.4271L13.3734 7.8926L12.7162 8.5498L14.2507 10.0843L14.9079 9.4271ZM5.2638 19.0743L3.7293 17.5398L3.0721 18.197L4.6066 19.7315L5.2638 19.0743ZM18.414 8.1127L15.7821 5.4808L15.1249 6.138L17.7568 8.7699L18.414 8.1127ZM13.5935 12.9363L10.9616 10.3044L10.3044 10.9616L12.9363 13.5935L13.5935 12.9363ZM8.7699 17.7568L6.138 15.1249L5.4808 15.7821L8.1127 18.414L8.7699 17.7568ZM0 19.9516L7.8926 27.8442L27.8411 7.8926L19.9485 0L0 19.9516ZM1.3175 19.9516L19.9485 1.3175L26.5236 7.8926L7.8926 26.5236L1.3175 19.9485V19.9516Z"
        fill="currentColor"
      />
    </svg>
  );
}
